import { render, staticRenderFns } from "./TwBenchmarkTagManagementDialog.vue?vue&type=template&id=3b060049&scoped=true"
import script from "./TwBenchmarkTagManagementDialog.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkTagManagementDialog.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkTagManagementDialog.vue?vue&type=style&index=0&id=3b060049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b060049",
  null
  
)

export default component.exports